import { useAppSelector } from '@features';
import { Button, Card } from '@repo/shadcn';
import { Link } from 'react-router-dom';

import { SectionContainer } from '@components/shared';
import {
    HeaderBreadcrumb,
    SectionDataTable,
    SectionTitle,
} from '@components/ui';

import { Route } from '@/constants';
import { expiredStockListColumns } from '@/modules/stocks/expired-stock-list/expired-stock-list.column';
import { useExpiredStockList } from '@/modules/stocks/expired-stock-list/expired-stock-list.hook';
import { StockListFilters } from '@/modules/stocks/shared';

export const ExpiredStockList = () => {
    const { data, isLoading, isFetching, isError, error } =
        useExpiredStockList();

    const items = useAppSelector((state) => state.expiryAdjustment.items) ?? [];

    const isRestockDisabled = !items || items.length <= 0;

    return (
        <SectionContainer
            isLoading={isLoading}
            isError={isError}
            error={error}
            fallbackPath={Route.DASHBOARD}
        >
            <Card className={'space-y-4 p-4'}>
                <div className={'flex justify-between'}>
                    <div className={'space-y-4'}>
                        <HeaderBreadcrumb
                            items={[
                                {
                                    label: 'Stocks',
                                    href: Route.STOCK_ALL_PRODUCTS,
                                },
                                { label: 'Expired Stock' },
                            ]}
                        />

                        <SectionTitle>Expired Stock Products</SectionTitle>
                    </div>

                    <Button disabled={isRestockDisabled} type={'button'}>
                        <Link to={Route.ADJUSTMENT_EXPIRED_PRODUCT_CREATE}>
                            Restock
                        </Link>
                    </Button>
                </div>

                <div className={'flex justify-between'}>
                    <StockListFilters searchPlaceholder={'expired stocks'} />
                </div>
                <SectionDataTable
                    columns={expiredStockListColumns}
                    data={data}
                    isLoading={isLoading || isFetching}
                />
            </Card>
        </SectionContainer>
    );
};

ExpiredStockList.displayName = 'ExpiredStockList';
